// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './backend/Vue-axios'
import store from './store/auth'
import { ValidationObserver, ValidationProvider, extend, localize, alpha, numeric, alpha_spaces } from 'vee-validate'
import en from 'vee-validate/dist/locale/en.json'
import * as rules from 'vee-validate/dist/rules'
import Vue2Filters from 'vue2-filters'
import moment from 'moment'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {fas} from '@fortawesome/free-solid-svg-icons'
import VueGoodTable from 'vue-good-table'
import VueCordovaDevice from 'vue-cordova-device'
import VuejsDialog from 'vuejs-dialog'
import CKEditor from '@ckeditor/ckeditor5-vue'
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import 'vue-good-table/dist/vue-good-table.css'
import './assets/css/default.css'
import './assets/css/rewrite.css'
import './assets/css/responsive.css'


Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})
localize('en', en)

// Install components globally
// Vue.prototype.$imageUrl = 'https://api.shopmonks.in:8001/'
Vue.prototype.$imageUrl = 'https://shopapi.dmonks.com:8001/'
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
Vue.use(VueCordovaDevice)
Vue.use(VueGoodTable)
console.log(Vue.cordova);
Vue.use(Vue2Filters)
// Global declaration for VuejsDialog
Vue.use(VuejsDialog, {
  loader: true
})
library.add(fas)
// fontawesome.library.add(brands)
Vue.use(CKEditor)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.filter('formatDate', (value) => {
  if (value) {
    return moment(String(value)).format('MMM DD YYYY hh:mm a')
  }
})


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js